<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="expert.id === null">{{ 'NEWEXPERT' | translate }}</span>
            <span *ngIf="expert.id !== null">{{ 'EDITEXPERT' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="expertForm" id="expertForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="expertForm" >
            <input type="hidden" name="id" id="expertId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="expertName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="expertName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="expertForm.controls['name'].invalid && (expertForm.controls['name'].dirty || expertForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="expertForm.controls['name'].errors !== null">
                  <div *ngIf="expertForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
          
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="expertNameFr" formControlName="nameFr" type="text" pInputText [required]="false"> 
                      <label for="expertNameFr" class="">{{ 'NAMEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
                  <div class="p-col-6">
                  
                    <div class="p-field p-col-12">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                          <i class="icon-marker-alt"></i>
                        </span>
                        <span class="p-float-label">
                          <input id="expertNameAr" formControlName="nameAr" type="text" pInputText [required]="false">
                          <label for="expertNameAr" class="">{{ 'NAMEAR' | translate }}</label>
                        </span>
                      </div>
                    </div>
                  
                  </div>
                  <!--/p-col-6-->
              <!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
           
              <!--/p-col-6-->
              <div class="p-col-6">
            
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="expertJob" formControlName="job" type="text" pInputText [required]="false">
                      <label for="expertJob" class="">{{ 'JOB' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div
                  *ngIf="expertForm.controls['job'].invalid && (expertForm.controls['job'].dirty || expertForm.controls['job'].touched)"
                  class="alert alert-danger">
                  <ng-container *ngIf="expertForm.controls['job'].errors !== null">
                    <div *ngIf="expertForm.controls['job'].errors.required">
                      {{ 'JOBREQUIRED' | translate }}.
                    </div>
                  </ng-container>
                </div>
            
              </div>
              <!--/p-col-6-->
              <div class="p-col-6">
              
                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="expertJobAr" formControlName="jobAr" type="text" pInputText [required]="false">
                      <label for="expertJobAr" class="">{{ 'JOBAR' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div
                  *ngIf="expertForm.controls['jobAr'].invalid && (expertForm.controls['jobAr'].dirty || expertForm.controls['jobAr'].touched)"
                  class="alert alert-danger">
                  <ng-container *ngIf="expertForm.controls['jobAr'].errors !== null">
                    <div *ngIf="expertForm.controls['jobAr'].errors.required">
                      {{ 'JOBREQUIRED' | translate }}.
                    </div>
                  </ng-container>
                </div>
              
              </div>
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-info-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="expertDescription" formControlName="description" type="text" pInputText [required]="false"> 
                      <label for="expertDescription" class="">{{ 'DESCRIPTION' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="expertPhoto" formControlName="photo" type="text" pInputText [required]="false"> 
                      <label for="expertPhoto" class="">{{ 'PHOTO' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('photo')"></button> 
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="expertIsPublished" formControlName="isPublished" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="expertIsPublished" class="p-d-inline-block p-ml-2 req">{{ 'ISPUBLISHED' | translate }}</label>
                </div>
                <div *ngIf="expertForm.controls['isPublished'].invalid && (expertForm.controls['isPublished'].dirty || expertForm.controls['isPublished'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="expertForm.controls['isPublished'].errors !== null">
                  <div *ngIf="expertForm.controls['isPublished'].errors.required">
                   {{ 'ISPUBLISHEDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKEXPERTS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="expert.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!expertForm.valid || disableSubmit"> <!--  [disabled]="expertForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!expertForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

